import React from "react";

function TodosError() {
    return(
        <p>Error al cargar la informacion.</p>
    );
}

export { TodosError };